<template>
<div class="hris-page">
  <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">System Settings</span>
      <h1 class="hris-page-title">Set Module Permissions Access</h1>
      <p class="hris-page-subtitle">Search for an employee to view and update their module access.</p>
    </div>

    <div class="hris-toolbar">
      <q-form ref="vForm" @submit="onSubmitSearch" class="full-width">
        <q-input v-model="searchModel" dense outlined color="green" :rules="[formRules.required]" placeholder="Search employee here...">
          <template v-slot:append>
            <q-icon name="fa fa-search"></q-icon>
          </template>
        </q-input>
      </q-form>
    </div>

    <div class="hris-panel">
      <h3 class="hris-panel-title">Search Result</h3>
      <q-table flat id="result-list" :data="searchResultData" :columns="searchResultColumns" row-key="id" :hide-bottom="searchResultData.length > 0" :loading="loading">
        <template v-slot:loading>
          <div class="hris-loading absolute-full flex flex-center" style="background: rgba(255,255,255,0.7); z-index: 1;">
            <q-spinner color="green" size="40px"></q-spinner>
            <div>Searching employees...</div>
          </div>
        </template>
        <q-tr slot="body" slot-scope="props" :props="props">
          <q-td key="employee_id" :props="props">{{ props.row.employee_id }}</q-td>
          <q-td key="name" :props="props">{{ props.row.name }}</q-td>
          <q-td key="position" :props="props">{{ props.row.position }}</q-td>
          <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          <q-td key="action" :props="props">
            <q-btn flat round dense class="hris-q-ghost" @click="listModules(props.row.id,props.row.name)">
              <i class="fa fa-lock" aria-hidden="true"></i>
              <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">Module Permissions Access</q-tooltip>
            </q-btn>
          </q-td>
        </q-tr>
        <template v-slot:no-data="{ message }">
          <div class="hris-empty full-width">{{ message }}</div>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="accessDialog" persistent transition-show="scale" transition-hide="scale">
      <div class="hris-modal hris-modal-lg">
        <div class="hris-modal-header">
          <div>
            <h2 class="hris-modal-title">Modules Permission</h2>
            <p class="hris-modal-subtitle">{{ empName }}</p>
          </div>
        </div>
        <div class="hris-modal-body">
          <div class="row q-col-gutter-sm" ref="accessDialogContents">
            <div class="col-6" v-for="mods in modaxs" :key="mods.id">
              <q-item tag="label">
                <q-item-section side top>
                  <q-toggle v-model="mods.enabled" checked-icon="fa fa-check" color="green" unchecked-icon="fa fa-times"></q-toggle>
                </q-item-section>
                <q-item-section>
                  <q-item-label class="qitemLabel">{{ humanize(mods.name) }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]" transition-show="scale" transition-hide="scale" :content-class="mods.enabled ? 'bg-red' : 'bg-green'" content-style="font-size: 13px">
                <div v-if="mods.enabled === true">
                  Click to disable module access.
                </div>
                <div v-else>
                  Click to enable module access.
                </div>
              </q-tooltip>
            </div>
          </div>
        </div>
        <div class="hris-modal-footer">
          <q-btn label="Close" class="hris-q-ghost" v-close-popup></q-btn>
          <q-btn unelevated :loading="modEffectLoading" @click="modulePermissionUpdate" class="hris-q-primary" label="Confirm">
            <template v-slot:loading>
              <q-spinner-gears class="on-left"></q-spinner-gears>
              Updating...
            </template>
          </q-btn>
        </div>
      </div>
    </q-dialog>
    <q-dialog v-model="loadingModel" persistent>
      <div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius); padding: 32px 44px;">
        <q-spinner color="green" size="40px"></q-spinner>
        <div>Loading Permissions</div>
      </div>
    </q-dialog>
  </div>
</div>
</template>
<script>
import axios from 'axios';

const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

export default {
  name: 'ModulePermissionsAccess',
  data() {
    return {
      empName: '',
      loadingModel: false,
      loading: false,
      modEffectLoading: false,
      accessDialog: false,
      accessGroup: [],
      confirmConfig: false,
      searchModel: null,
      searchResultData: [],
      searchResultColumns: [{
          name: 'employee_id',
          field: 'employee_id',
          label: 'Employee ID',
          style: 'width: 200px',
          align: 'center',
          headerStyle: 'width: 200px'
        },
        {
          name: 'name',
          field: 'name',
          label: 'Name',
          style: 'width: 300px; padding-left: 100px',
          align: 'left',
          headerStyle: 'width: 300px; text-align:center'
        },
        {
          name: 'position',
          field: 'position',
          label: 'Position',
          style: 'width: 300px; padding-left: 100px',
          align: 'left',
          headerStyle: 'width: 300px; text-align:center'
        },
        {
          name: 'department',
          field: 'department',
          label: 'Department',
          align: 'center',
        },
        {
          name: 'action',
          field: 'action',
          label: 'Action',
          align: 'center',
        }
      ],
      modules: [],
      modaxsInit: [],
      modaxs: [],
      updatedMods: [],
      selectedIsAdmin: false,
      selectedEmployeeId: 0,
      borderRadius: 'border-radius'
    }
  },
  methods: {
    onSubmitSearch: function() {
      this.loading = true;
      this.modulesArea = false;

      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .get('/employees/search', {
          params: {
            keyword: this.searchModel
          }
        })
        .then((res) => {
          this.loading = false;
          this.searchResultData = [];
          if (res.data.data.length > 0) {
            for (let emp of res.data.data) {
              this.searchResultData.push({
                id: emp.id,
                name: this.toTitleCase(emp.name),
                employee_id: emp.employee_id,
                position: emp.position,
                department: emp.department
              });
            }
          } else {
            this.modulesArea = false;
            this.confirmConfig = false;
          }
        })
    },

    listModules: function(id, name) {
      this.loadingModel = true;
      this.accessDialog = true;
      this.selectedEmployeeId = id;
      this.empName = name;

      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .get('/employees/module/modules-permission-access', {
          params: {
            id: id,
          }
        })
        .then((res) => {
          this.loadingModel = false;
          this.modules = res.data.data;
          let modLength = this.modules.length;
          this.modaxsInit = [];
          this.modaxs = [];
          var i;

          for (i = 1; i < modLength; i++) {
            this.modaxs.push({
              id: this.modules[i].id,
              name: this.humanize(this.modules[i].name),
              enabled: this.modules[i].enabled,
            });
            this.modaxsInit.push({
              id: this.modules[i].id,
              name: this.humanize(this.modules[i].name),
              enabled: this.modules[i].enabled
            });
          }
          this.confirmConfig = true;
        })
    },

    modulePermissionUpdate: function() {
      this.updatedMods = [];
      for (let mod of this.modaxs) {
        this.updatedMods.push({
          id: mod.id,
          name: mod.name,
          enabled: mod.enabled
        });
      }

      if (JSON.stringify(this.modaxs) === JSON.stringify(this.modaxsInit)) {
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'No changes made in modules permission.'
        });
      } else {
        this.modEffectLoading = true;

        let formData = new FormData();

        formData.append('employee_id', this.selectedEmployeeId);
        formData.append('modules', JSON.stringify(this.updatedMods));

        axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        }).post('/employees/module/set-modules-permission-access', formData).then((res) => {
          console.log('Modules Permission Set Success');
        })

        setTimeout(() => {
          this.modEffectLoading = false;
          this.$q.notify({
            color: 'green-7',
            textColor: 'white',
            icon: 'fa fa-cogs',
            message: 'Modules permission set success.'
          });
          this.accessDialog = false;
        }, 1500);
      }
    }
  }
}
</script>
<style lang="css" scoped>
.qitemLabel {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.text-h6 {
  font-size: 14px;
}

#result-list tr:hover {
  cursor: default;
}
</style>